const APPLICATION_ERROR_RULES = [
  {
    includes: '募集人数に達しています',
    message: '募集人数に達しています。募集上限を編集してから承認するようにしてください',
  },
  {
    includes: '既に応募しています',
    message: '既に応募しています。',
  },
  {
    includes: '募集が見つかりません',
    message: '募集が見つかりません。',
  },
  {
    includes: '応募が見つかりません',
    message: '応募が見つかりません。',
  },
  {
    includes: '自分の募集には応募できません',
    message: '自分の募集には応募できません。',
  },
  {
    includes: 'この募集は現在応募できません',
    message: 'この募集は現在応募できません。',
  },
  {
    includes: 'この募集はプロフィール性別が一致する人のみ応募可能です',
    message: 'この募集はプロフィール性別が一致する人のみ応募可能です。',
  },
  {
    includes: '現在、応募機能を利用できません',
    message: '現在、応募機能を利用できません。',
  },
  {
    includes: '主催者のみ承認できます',
    message: '主催者のみ承認できます。',
  },
  {
    includes: '主催者のみ拒否できます',
    message: '主催者のみ拒否できます。',
  },
  {
    includes: '応募者本人のみキャンセルできます',
    message: '応募者本人のみキャンセルできます。',
  },
  {
    includes: '承認済みの応募のみ解除できます',
    message: '承認済みの応募のみ解除できます。',
  },
  {
    includes: '拒否済みの応募のみ解除できます',
    message: '拒否済みの応募のみ解除できます。',
  },
  {
    includes: '主催者のみ承認解除できます',
    message: '主催者のみ承認解除できます。',
  },
  {
    includes: '主催者のみ拒否解除できます',
    message: '主催者のみ拒否解除できます。',
  },
];

const CODE_ERROR_MESSAGES = {
  'functions/unauthenticated': 'ログインが必要です。',
  unauthenticated: 'ログインが必要です。',
  'functions/permission-denied': 'この操作を行う権限がありません。',
  'permission-denied': 'この操作を行う権限がありません。',
  'functions/not-found': '対象データが見つかりません。',
  'not-found': '対象データが見つかりません。',
  'functions/resource-exhausted': '短時間に操作が集中しています。少し待ってから再度お試しください。',
  'resource-exhausted': '短時間に操作が集中しています。少し待ってから再度お試しください。',
  'functions/unavailable': '一時的にサーバーへ接続できません。少し待ってから再度お試しください。',
  unavailable: '一時的にサーバーへ接続できません。少し待ってから再度お試しください。',
};

export function getCallableErrorMessage(error, fallbackMessage) {
  const rawMessage = String(error?.message || '');
  const rawCode = String(error?.code || '');
  const target = `${rawCode}\n${rawMessage}`;

  const matchedRule = APPLICATION_ERROR_RULES.find((rule) => target.includes(rule.includes));
  if (matchedRule) return matchedRule.message;

  if (CODE_ERROR_MESSAGES[rawCode]) return CODE_ERROR_MESSAGES[rawCode];

  return fallbackMessage || '操作に失敗しました。もう一度お試しください。';
}
